import PropTypes from 'prop-types';
import React from 'react';
import {
  Alert, Container, Col, Row,
} from 'reactstrap';
import './index.scss';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import rendererOptions from '../../../richtext-rendering/renderer-options';

export default function AlertBox({ alertBoxData }) {
  return (
    <Container className="py-3" data-cy="covid-alert" fluid>
      <Row>
        <Col className="mx-auto" md={6}>
          <Alert className="mx-auto my-0" color="secondary">
            <div className="alert-text">{renderRichText(alertBoxData, rendererOptions)}</div>
          </Alert>
        </Col>
      </Row>
    </Container>
  );
}

AlertBox.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  alertBoxData: PropTypes.object.isRequired,
};
